// import _ from "lodash";
import htmlToPdfmake from "html-to-pdfmake";
import Report from "report";
import TableReportHelper from "report/helper";



export default class CatalogoReport extends Report {
    constructor(obj) {
        super();
        this.obj = obj;

        if (this.obj.inscritos) {
            // let eligibleParticipants = this.obj.inscritos.filter(p => (p.statusEvento === "PRESENTE" || p.statusEvento === "SAIU") && p.status === "INSCRITO" && p.termo)
            let eligibleParticipants = this.obj.inscritos.filter(p => p.status === "INSCRITO" && p.termo)

            let sortedParticipants = eligibleParticipants.sort((a, b) => a.empresa.nomeEmpresaCracha.localeCompare(b.empresa.nomeEmpresaCracha))
            this.obj.inscritos = sortedParticipants
        }

    }
   

    get title() {
        return "Catálogo de Oportunidades";
    }


    get fileName() {
        return this.title;
    }

    async render() {
        console.log('this.obj', this.obj)
        this.helper = new TableReportHelper(this.obj);
        return [
            await this.renderHeader(),
            await this.renderCustomCapa(),
            await this.renderAncoras(),
            await this.renderFornecedores(),
        ]
    }

    renderHeader() {
        const h = this.helper;
        const content = [
            h.panel(
                [
                    h.row(
                        h.title("CATÁLOGO DE OPORTUNIDADE", { fontSize: 16, alignment: 'center' }),
                    ),
                    h.row(
                        h.text(this.obj.rodada.nome, { fontSize: 16, alignment: 'center' }),
                    ),
                    h.row(
                        h.text(this.obj.rodada.descricao, { fontSize: 14, alignment: 'center' }),
                    ),
                ],
                { widths: ["*"], unbreakable: true, margin: [0, 250, 0, 0] }
            ),
        ];

        return content;
    }
    renderCustomCapa() {
        if (this.obj.rodada.capaCatalogo) {
            let htmlRel = htmlToPdfmake(this.obj.rodada.capaCatalogo, {
                "removeExtraBlanks": true,
                "defaultStyles": {
                    "p": { "margin": [0, 1, 0, 4] }
                }
            })


            let tableHtml = {
                // style: custom.style,
                layout: 'noBorders',
                table: {
                    body: htmlRel.map(h => [h])
                },
            };

            // return tableHtml
            const h = this.helper;
            const content = [
                h.pageBreak(),
                tableHtml,
            ];

            return content;
        }

        return null;
    }
    txtProdutos(produtos) {
        let r = ""

        produtos.forEach(p => {
            r += p.produto ? p.produto.nome + "; " : p.nome + "; "
        })
        return r
    }
    async renderAncoras() {

        const h = this.helper;

        const content = [
            h.pageBreak(),
            h.panel(
                [
                    h.row(
                        h.title("EMPRESAS ÂNCORAS (EMPRESAS FIXAS NAS MESAS DE NEGOCIAÇÃO)", { fontSize: 14 }),
                    )
                    ,
                ],
                { widths: ["*"], unbreakable: true }
            ),
        ];

        this.obj.inscritos?.filter(i => i.tipo === "ÂNCORA").forEach(a => {
            // let produtosArr = []
            // if (a.empresa.produtosCompra && a.empresa.produtosCompra.length) produtosArr = [...produtosArr, ...a.empresa.produtosCompra]
            // if (a.empresa.produtosVenda && a.empresa.produtosVenda.length) produtosArr = [...produtosArr, ...a.empresa.produtosVenda]

            content.push(h.panel([
                h.row(h.title(a.empresa.nomeEmpresaCracha, { fontSize: 12, colSpan: 4 }),),
                h.row(h.title("CNPJ:"), h.text(a.empresa.cnpj, { colSpan: 3 })),
                h.row(h.title("RAZÃO SOCIAL:"), h.text(a.empresa.razaoSocial, { colSpan: 3 })),
                h.row(h.title("ENDEREÇO: "), h.text(a.empresa.endereco, { colSpan: 3 })),
                h.row(h.title("TELEFONE: "), h.text(a.empresa.telComercial), h.title("CELULAR: "), h.text(a.empresa.celular),),
                h.row(h.title("E-MAIL:"), h.text(a.empresa.email, { colSpan: 3 })),
                h.row(h.title("PARTICIPANTE:"), h.text(a.empresa.funcionarios.nomeCracha ? a.empresa.funcionarios.nomeCracha : a.empresa.funcionarios.nomeParticipante, { colSpan: 3 })),
                h.row(h.title("PRODUTOS E SERVIÇOS DA EMPRESA", { fontSize: 10, colSpan: 4 }),),
                // h.row(h.title("PRODUTOS/SERVIÇOS:"), h.text(this.txtProdutos(produtosArr), { colSpan: 3 })),
                h.row(h.title("PRODUTOS/SERVIÇOS PARA COMPRA:"), h.text(this.txtProdutos(a.empresa.produtosCompra || []), { colSpan: 3 })),
                h.row(h.title("PRODUTOS/SERVIÇOS PARA VENDA:"), h.text(this.txtProdutos(a.empresa.produtosVenda || []), { colSpan: 3 })),
                h.row(h.title("DESCRIÇÃO DA EMPRESA:"), h.text(a.empresa.descricaoEmpresa, { colSpan: 3 })),
            ], { widths: [80, "*", 80, "*"], unbreakable: true, margin: [0, 15, 0, 0] }
            ),)
        });



        return content;
    }

    async renderFornecedores() {

        const h = this.helper;

        const content = [
            h.pageBreak(),
            h.panel(
                [

                    h.row(
                        h.title("EMPRESAS FLUTUANTES (EMPRESAS QUE SE MOVIMENTAM ENTRE AS MESAS DE NEGOCIAÇÃO)", { fontSize: 14 }),
                    )
                    ,
                ],
                { widths: ["*"], unbreakable: true }
            ),
        ];

        this.obj.inscritos?.filter(i => i.tipo === "FORNECEDOR").forEach(a => {
            // let produtosArr = []
            // if (a.empresa.produtosCompra && a.empresa.produtosCompra.length) produtosArr = [...produtosArr, ...a.empresa.produtosCompra]
            // if (a.empresa.produtosVenda && a.empresa.produtosVenda.length) produtosArr = [...produtosArr, ...a.empresa.produtosVenda]

            content.push(h.panel([
                h.row(h.title(a.empresa.nomeEmpresaCracha, { fontSize: 12, colSpan: 4 }),),
                h.row(h.title("CNPJ:"), h.text(a.empresa.cnpj, { colSpan: 3 })),
                h.row(h.title("RAZÃO SOCIAL:"), h.text(a.empresa.razaoSocial, { colSpan: 3 })),
                h.row(h.title("ENDEREÇO: "), h.text(a.empresa.endereco, { colSpan: 3 })),
                h.row(h.title("TELEFONE: "), h.text(a.empresa.telComercial), h.title("CELULAR: "), h.text(a.empresa.celular),),
                h.row(h.title("E-MAIL:"), h.text(a.empresa.email, { colSpan: 3 })),
                h.row(h.title("PARTICIPANTE:"), h.text(a.empresa.funcionarios.nomeCracha ? a.empresa.funcionarios.nomeCracha : a.empresa.funcionarios.nomeParticipante, { colSpan: 3 })),
                h.row(h.title("PRODUTOS E SERVIÇOS DA EMPRESA", { fontSize: 10, colSpan: 4 }),),
                // h.row(h.title("PRODUTOS/SERVIÇOS:"), h.text(this.txtProdutos(produtosArr), { colSpan: 3 })),
                h.row(h.title("PRODUTOS/SERVIÇOS PARA COMPRA:"), h.text(this.txtProdutos(a.empresa.produtosCompra || []), { colSpan: 3 })),
                h.row(h.title("PRODUTOS/SERVIÇOS PARA VENDA:"), h.text(this.txtProdutos(a.empresa.produtosVenda || []), { colSpan: 3 })),
                h.row(h.title("DESCRIÇÃO DA EMPRESA:"), h.text(a.empresa.descricaoEmpresa, { colSpan: 3 })),
            ], { widths: [80, "*", 80, "*"], unbreakable: true, margin: [0, 15, 0, 0] }
            ),)
        });



        return content;
    }


}
